import { isString } from 'lodash';
import { FileUpload } from '@shared/components/blocks/types';
import { API } from '@shared/types/api';

const imageExtensions = ['webp', 'jpg', 'jpeg', 'png', 'gif', 'heic'];
const imageContentTypes = imageExtensions.map(ext => `image/${ext}`);
const videoExtensions = ['mp4', 'mov', 'quicktime', 'webm'];
const videoContentTypes = videoExtensions.map(ext => `video/${ext}`);

export function getFilenameFromUrl(url: string) {
  const filename = url
    ?.split('?')[0]
    ?.split('.')
    .reverse()[1]
    ?.split('/')
    .reverse()[0]
    ?.toLowerCase();

  return filename;
}

export function getExtensionFromUrl(url: string) {
  const extension = url?.split('?')[0]?.split('.').reverse()[0]?.toLowerCase();
  return extension;
}

export function getFilenameWithExtensionFromUrl(url: string) {
  return `${getFilenameFromUrl(url)}.${getExtensionFromUrl(url)}`;
}

export function getFilenameParts(name: string): [string, string | undefined] {
  const parts = name.split('.');
  const extension = parts.pop();
  const filename = parts.join('.');
  return [filename, extension];
}

export type MediaType = 'image' | 'video' | 'any';

export function getMediaType(extension?: string | null, contentType?: string | null): MediaType {
  if (isImageExtension(extension) || isImageContentType(contentType)) {
    return 'image';
  } else if (isVideoExtension(extension) || isVideoContentType(contentType)) {
    return 'video';
  }
  return 'any';
}

export function isImage(file: FileUpload | API.ChatAttachmentFragment) {
  const extension = getExtensionFromUrl(file.url);
  const mediaType = getMediaType(extension, file.contentType);
  return mediaType === 'image';
}

function isImageExtension(extension?: string | null) {
  return isString(extension) && imageExtensions.includes(extension);
}
function isImageContentType(contentType?: string | null) {
  return isString(contentType) && imageContentTypes.includes(contentType);
}
function isVideoExtension(extension?: string | null) {
  return isString(extension) && videoExtensions.includes(extension);
}
function isVideoContentType(contentType?: string | null) {
  return isString(contentType) && videoContentTypes.includes(contentType);
}
